import { render, staticRenderFns } from "./ActivationBriefShippingProvider.vue?vue&type=template&id=6c014a40&"
import script from "./ActivationBriefShippingProvider.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefShippingProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports